require('url-search-params-polyfill');

module.exports = function($rootScope) {
    return {
        request: function (config) {
            // Add header for the participant if it's set either in root scope or as a URL param.
            if ($rootScope.participantHash) {
                config.headers['X-Participant-Hash'] = $rootScope.participantHash;
            }
            else if (URLSearchParams !== undefined) {
                var urlParams = new URLSearchParams(window.location.search);
                var participantHash = urlParams.get('partHash');

                if (participantHash) {
                    config.headers['X-Participant-Hash'] = participantHash;
                }
            }

            return config;
        }
    };
}